import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

/**
 * Production-grade Firebase Analytics helpers for CampusIRA.
 * All functions are safe to call even if analytics is null (SSR / ad-blocker).
 */

const safeLog = (eventName, params = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

// ── Page / Route Tracking ─────────────────────────────────────────────────
export const trackPageView = (path, title) => {
  safeLog("page_view", {
    page_path: path,
    page_title: title || document.title,
  });
};

// ── Content Engagement ────────────────────────────────────────────────────
export const logPostView = (companyName) => {
  safeLog("interview_read", { company: companyName });
};

// ── CTA / Button Clicks ──────────────────────────────────────────────────
export const trackCTAClick = (ctaName, destination) => {
  safeLog("cta_click", {
    cta_name: ctaName,
    destination: destination || "unknown",
  });
};

// ── Form Events ───────────────────────────────────────────────────────────
export const trackFormSubmit = (formName) => {
  safeLog("form_submit", { form_name: formName });
};

// ── Auth Events ───────────────────────────────────────────────────────────
export const trackSignUp = (method) => {
  safeLog("sign_up", { method: method || "google" });
};

export const trackLogin = (method) => {
  safeLog("login", { method: method || "google" });
};

// ── Outbound Links ────────────────────────────────────────────────────────
export const trackOutboundLink = (url) => {
  safeLog("outbound_link", { url });
};

// ── Error Tracking ────────────────────────────────────────────────────────
export const trackError = (errorMsg, source) => {
  safeLog("app_error", {
    error_message: errorMsg?.substring?.(0, 100) || "unknown",
    error_source: source || "unknown",
  });
};